import TipoTareaService from "@/api/services/tarea/TipoTareaService"
import Vue from "vue"

const state = () => ({
    tipos_tarea: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "id",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    TIPOS_TAREA: state => {
        return state.tipos_tarea
    },
    TIPOS_TAREA_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_TIPOS_TAREA: (state, payload) => {
        state.tipos_tarea = payload
    },

    SET_TIPOS_TAREA_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_TIPO_TAREA: (state, payload) => {
        state.tipos_tarea.push(payload)
    },

    UPDATE_TIPO_TAREA: (state, payload) => {
        state.tipos_tarea = state.tipos_tarea.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_TIPO_TAREA: (state, payload) => {
        state.tipos_tarea = state.tipos_tarea.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_TIPOS_TAREA: async ({ commit, state }, { filter, tipoTareaEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await TipoTareaService.get({ filter, tipoTareaEstado, ...pagination })
            if (status === 200) {
                commit("SET_TIPOS_TAREA", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los tipos de tarea, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_TIPOS_TAREA: async ({ commit }) => {
        try {
            let { data, status } = await TipoTareaService.getAll()
            if (status === 200) {
                commit("SET_TIPOS_TAREA", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se han podido cargar los tipos de tarea, inténtelo nuevamente"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_TIPOS_TAREA: async ({ commit }) => {
        try {
            let { data, status } = await TipoTareaService.getAllRecords()
            if (status === 200) {
                commit("SET_TIPOS_TAREA", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los tipos de tarea, inténtelo nuevamente"
            })
        }
    },

    ADD_TIPO_TAREA: async ({ commit }, payload) => {
        try {
            let { data, status } = await TipoTareaService.post(payload)
            if (status === 201) {
                commit("ADD_TIPO_TAREA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El tipo de tarea ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el tipo de tarea, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_TIPO_TAREA: async ({ commit }, payload) => {
        try {
            let { data, status } = await TipoTareaService.put(payload)
            if (status === 200) {
                commit("UPDATE_TIPO_TAREA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El tipo de tarea ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el tipo tarea, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_TIPO_TAREA: async ({ commit }, payload) => {
        try {
            let { status, data } = await TipoTareaService.delete(payload)
            if (status === 204) {
                commit("DELETE_TIPO_TAREA", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El tipo de tarea ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_TIPO_TAREA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El tipo de tarea ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el tipo de tarea, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
